import Vue from "vue";
import VueI18n from "vue-i18n";
// import pt from "vuetify/lib/locale/pt";

const dateTimeFormats = {
  "pt-br": {
    short: {
      year: "numeric",
      month: "numeric",
      day: "numeric"
    },
    superShort: {
      month: "numeric",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric"
    },
    dateAndTime: {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric"
    }
  }
};

const numberFormats = {
  "pt-br": {
    currency: {
      style: "currency",
      currency: "BRL"
    }
  }
};

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export default new VueI18n({
  dateTimeFormats,
  numberFormats,
  locale: 'pt-br',
  fallbackLocale: 'pt-br',
  messages: loadLocaleMessages()
  /*  lang: {
    locales: { pt },
    current: pt
  } */
});
